import { isEqual } from 'lodash';
import {
  InvestorAccessPermission,
  InvestorAccessPermissionGroup,
  InvestorAccessPermissionGroupKey,
} from 'further-types/further-user';

export const InvestorAccessPermissionGroupNames: Record<
  InvestorAccessPermissionGroupKey,
  string
> = {
  Full: 'Full access',
  ReadOnly: 'Read-only',
  FullExceptSigning: 'Full access except signing',
};

export const getInvestorPermissionsGroup = (
  permissions: Array<InvestorAccessPermission>,
  returnAsKey = false,
) => {
  const keys = Object.keys(InvestorAccessPermissionGroup) as Array<
    keyof typeof InvestorAccessPermissionGroup
  >;

  const presetPermissionsGroup = keys.find((key) =>
    isEqual(new Set(permissions), new Set(InvestorAccessPermissionGroup[key])),
  );
  if (!presetPermissionsGroup) {
    return returnAsKey ? 'custom' : 'Custom';
  }

  return returnAsKey
    ? presetPermissionsGroup
    : InvestorAccessPermissionGroupNames[presetPermissionsGroup];
};

export const getInvestorAccessPermissionGroupOptions = () => {
  return Object.keys(InvestorAccessPermissionGroup).map((key) => ({
    label:
      InvestorAccessPermissionGroupNames[
        key as InvestorAccessPermissionGroupKey
      ],
    value: key,
  }));
};
